<template>
  <!-- 活动分销产品 -->
  <div class="fen-root">
    <section style="font-size:0">
      <img :src="storeInfo.image" width="100%">
      <p v-show="status && status.show" class="section-timer">{{status.text}}{{status.days}}天{{' '}}{{status.hours}}:{{status.minutes}}:{{status.seconds}}</p>
    </section>
    <section class="summary">
      <p>{{storeInfo.store_info}}</p>
    </section>
    <!--<section class="participant">-->
      <!--<p class="section-title">参与者</p>-->
    <!--</section>-->
    <section class="introduction">
      <p class="section-title">活动介绍</p>
      <div class="intro-content">
      <p v-for="(item, index) in storeInfo.slider_image" :key="index">
      <img :src="item" width="100%">
      </p>
      </div>
      <section class="address">
        <!--
        <p class="section-title">门店位置</p>
        <div class="section-content">
          {{systemStore.address.join(" ") + systemStore.detailed_address}}
        </div>
        -->
        <p class="section-title">健康地址(娄星区):</p>
        <div class="section-content">
          <div>一店：南贸东街翰林苑15-16号(美健经典店)</div>
          <div>二店：吉星南路115号克丽缇娜(金益紫檀店)</div>
        </div>
      </section>
      <div class="zhanwei"></div>
    </section>
    <section class="copyright">
      一道信息 提供技术支持
    </section>
      <div class="zhanwei"></div>
    <div class="zhanwei"></div>
    <div class="footer" v-show="!showForm">
      <a v-if="purchased" class="buynow">
        已抢购成功:-)
      </a>
      <a v-else-if="status.active" class="buynow" @click="showForm = true;">
        立即抢购(￥{{storeInfo.price}})
      </a>
      <a v-else class="buynow">
        {{status.title}}
      </a>
      <a class="share" @click="setPosterImageStatus">分享</a>
    </div>
    <section class="user-info-form" v-show="showForm">
      <div class="mask" @click="showForm = false;"></div>
      <div class="form">
        <div class="form-title">基本信息</div>
        <div class="input-area">
          <div class="input-item">
            <span>姓名：</span><input v-model="real_name">
          </div>
          <div class="input-item">
            <span>电话：</span><input v-model="phone">
          </div>
        </div>
        <div class="button">
          <button @click="confirmcontent">确认并继续</button>
        </div>
      </div>
    </section>
    <aside class="right">
      <div :class="isOnPlay?'musicIcon':'musicIconX'" @click="controlMusic"></div>
      <div><a class="phoneIcon" :href="'tel:'+systemStore.phone"></a></div>
      <div class="shareIcon" @click="setPosterImageStatus"></div>
      <audio ref="audioIds" loop :src="storeInfo.music_link" id="media" autoplay></audio>
    </aside>
    <aside class="right-bottom" v-show="false">
      <div class="brokerageIcon" @click="goBrokerage"></div>
    </aside>
    <StorePoster
      v-on:setPosterImageStatus="setPosterImageStatus"
      :posterImageStatus="posterImageStatus"
      :posterData="posterData"
    ></StorePoster>
  </div>
</template>
<script>
import {
  getProductDetail,
  postCartAdd,
  getCartCount,
  getProductCode,
  storeListApi,
  getProductPurchased,
} from "@api/store";
import StorePoster from "@components/StorePoster";
import {
  getCoupon,
  getCollectAdd,
  getCollectDel,
  getUser,
  getUserInfo
} from "@api/user";
import {
  createOrder,
  postOrderConfirm, 
  postOrderComputed,
} from "@api/order";
import { pay } from "@libs/wechat";
import { isWeixin } from "@utils/index";
import { wechatEvevt } from "@libs/wechat";
import { imageBase64 } from "@api/public";
import { mapGetters } from "vuex";
import cookie from "@utils/store/cookie";
let NAME = "GoodsConSingle";
const LONGITUDE = "user_longitude";
const LATITUDE = "user_latitude";
export default {
  name: NAME,
  components: {
    StorePoster,
  },
  data: function() {
    return {
      posterData: {
        image: "",
        title: "",
        price: "",
        code: "",
        avatar: "",
        nickname: ""
      },
      posterImageStatus: false,
      id: 0,
      storeInfo: {},
      systemStore: {},
      real_name: "",
      phone: "",
      address_detail: "",
      showForm: false,
      purchased: false,
      isOnPlay: true,
      active: process.env.NODE_ENV !== "production" ? "yue" : "weixin",
      start_time: null,
      stop_time: null,
      now_time: 0,
      timer: null,
    };
  },
  computed: {
    ...mapGetters(["isLogin"]),
    status: function() {
      let sec, days, hours, minutes, seconds, show, title, text, active, n;
      active = false;
      if (!this.start_time || !this.stop_time) {
        show = false;
        title = '';
        text = '';
        active = true;
      } else if (this.now_time < this.start_time) {
        sec = this.start_time - this.now_time;
        show = true;
        title = '即将开始';
        text = '距离活动开始还有: ';
      } else if (this.now_time > this.stop_time) {
        sec = 0;
        show = true;
        title = '活动已结束';
        text = '活动已结束: ';
      } else {
        sec = this.stop_time - this.now_time;
        show = true;
        title = '活动进行中';
        text = '距离活动结束剩余: ';
        active = true;
      }
      n = sec;
      seconds = n % 60;
      n = (n - seconds) / 60; //总分钟数
      minutes = n % 60;
      n = (n-minutes)/60;  //总小时数
      hours = n % 24;
      n = (n-hours)/24; //总天数
      days = n;
      seconds = (seconds + '').length === 1 ? '0' + seconds : '' + seconds;
      minutes = (minutes + '').length === 1 ? '0' + minutes : '' + minutes;
      hours = (hours + '').length === 1 ? '0' + hours : '' + hours;
      return {show: show, title: title, text: text, days: days, hours: hours, minutes: minutes, seconds: seconds, active: active};
    } 
  },
  watch: {
    $route(n) {
      if (n.name === NAME) {
        this.id = n.params.id;
        this.storeInfo.slider_image = [];
        this.productCon();
      }
    },
  },
  updated() {
    // window.scroll(0, 0);
  },
  mounted: function() {
    let that = this;
    this.User();
    this.id = this.$route.params.id;
    this.storeInfo.slider_image = [];
    this.productCon();
    that.now_time = Math.round((new Date()).getTime()/1000);
    that.timer = setInterval(function() {
      that.now_time++;
    }, 1000);
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
  methods: {
    User: function() {
      let that = this;
      getUser().then(res => {
        let userInfo = res.data;
        that.posterData.avatar = userInfo.avatar;
        that.posterData.nickname = userInfo.nickname;
      });
    },
    controlMusic() {
      const oDiv = this.$refs.audioIds;
      if (this.isOnPlay) {
        oDiv.pause();
        this.isOnPlay = false;
      } else {
        oDiv.play();
        this.isOnPlay = true;
      }
    },
    getImageBase64: function() {
      let that = this;
      imageBase64(this.posterData.avatar, that.posterData.code)
        .then(res => {
          that.posterData.avatar = res.data.image;
          that.posterData.code = res.data.code;
          that.isLogin && that.shareCode();
        })
        .catch(() => {
          that.isLogin && that.shareCode();
        });
      imageBase64(this.posterData.image, that.posterData.code)
        .then(res => {
          that.posterData.image = res.data.image;
          that.posterData.code = res.data.code;
          that.isLogin && that.shareCode();
        })
        .catch(() => {
          that.isLogin && that.shareCode();
        });
    },
    setShareInfoStatus: function() {
      this.shareInfoStatus = !this.shareInfoStatus;
      this.posters = false;
    },
    shareCode: function(value) {
      var that = this;
      getProductCode(that.id).then(res => {
        if (res.data.code) that.posterData.code = res.data.code;
        value === false && that.listenerActionSheet();
      });
    },
    setPosterImageStatus: function() {
      var sTop = document.body || document.documentElement;
      sTop.scrollTop = 0;
      this.posterImageStatus = !this.posterImageStatus;
      this.posters = false;
    },
    //产品详情接口；
    productCon: function() {
      let that = this;
      getProductDetail(that.id)
        .then(res => {
          that.$set(that, "storeInfo", res.data.storeInfo);
          that.$set(that, "systemStore", res.data.system_store);
          that.posterData.image = that.storeInfo.image_base;
          if (that.storeInfo.store_name.length > 30) {
            that.posterData.title =
              that.storeInfo.store_name.substring(0, 30) + "...";
          } else {
            that.posterData.title = that.storeInfo.store_name;
          }
          that.posterData.price = that.storeInfo.price;
          that.posterData.code = that.storeInfo.code_base;
          that.getImageBase64();
          that.start_time = res.data.simple_start_time;
          that.stop_time = res.data.simple_stop_time;
          that.updateTitle();
          that.setOpenShare();
        })
        .catch(res => {
          that.$dialog.error(res.msg);
          that.$router.go(-1);
        });
      getProductPurchased(that.id)
        .then(res => {
          that.$set(that, "purchased", res.data.purchased);
        })
        .catch(res => {
          that.$dialog.error(res.msg);
          that.$router.go(-1);
        });
    },
    setOpenShare: function() {
      var data = this.storeInfo;
      var href = location.href;
      if (isWeixin()) {
        if (this.isLogin) {
          getUserInfo().then(res => {
            href =
              href.indexOf("?") === -1
                ? href + "?spread=" + res.data.uid
                : href + "&spread=" + res.data.uid;
            var configAppMessage = {
              desc: data.store_info,
              title: data.store_name,
              link: href,
              imgUrl: data.image
            };
            wechatEvevt(
              [
                "updateAppMessageShareData",
                "updateTimelineShareData",
                "onMenuShareAppMessage",
                "onMenuShareTimeline"
              ],
              configAppMessage
            )
              .then(res => {
                console.log(res);
              })
              .catch(res => {
                if (res.is_ready) {
                  res.wx.updateAppMessageShareData(configAppMessage);
                  res.wx.onMenuShareAppMessage(configAppMessage);
                  res.wx.updateTimelineShareData(configAppMessage);
                  res.wx.onMenuShareTimeline(configAppMessage);
                }
              });
          });
        } else {
          var configAppMessage = {
            desc: data.store_info,
            title: data.store_name,
            link: href,
            imgUrl: data.image
          };
          wechatEvevt(
            [
              "updateAppMessageShareData",
              "updateTimelineShareData",
              "onMenuShareAppMessage",
              "onMenuShareTimeline"
            ],
            configAppMessage
          )
            .then(res => {
              console.log(res);
            })
            .catch(res => {
              if (res.is_ready) {
                res.wx.updateAppMessageShareData(configAppMessage);
                res.wx.onMenuShareAppMessage(configAppMessage);
                res.wx.updateTimelineShareData(configAppMessage);
                res.wx.onMenuShareTimeline(configAppMessage);
              }
            });
        }
      }
    },
    confirmcontent() {
      if (!this.real_name) return this.$dialog.toast({mes: "请输入姓名"});
      if (!this.phone) return this.$dialog.toast({mes: "请输入电话"});
      if (!/^1(3|4|5|7|8|9|6)\d{9}$/.test(this.phone)) {
        return this.$dialog.toast({ mes: "请填写正确的手机号" });
      }

      let that = this;
      let q = {
        productId: that.id,
        cartNum: 1,
        new: 1,
        uniqueId: "",
        real_name: that.real_name,
        phone: that.phone
      };
      postCartAdd(q).
        then(function(res) {
          let cartId = res.data.cartId + '';
          postOrderConfirm(cartId)
            .then(res => {
              let orderGroupInfo = res.data;
              that.createOrder(orderGroupInfo);
            })
            .catch(() => { // postOrderConfirm
            });
        })
        .catch(res => {
          return that.$dialog.toast({mes:res.msg});
        });
    },
    updateTitle() {
      document.title = this.storeInfo.store_name || this.$route.meta.title;
    },
    createOrder: function(orderGroupInfo) {
      let that = this;
      createOrder(orderGroupInfo.orderKey, {
        real_name: that.real_name,
        phone: that.phone,
        addressId: orderGroupInfo.addressInfo.id,
        useIntegral: 0,
        couponId: 0,
        payType: that.active,
        pinkId: 0,
        seckill_id: 0,
        combinationId: 0,
        bargainId: 0,
        from: "weixin",
        mark: "",
        shipping_type: 2,
        store_id: this.systemStore.id,
        spread_uid: cookie.get("spread"),
        simple_id: that.id,
      })
        .then(res => {
          that.$dialog.loading.close();
          const data = res.data;
          //let url = "/order/status/" + data.result.orderId;
          switch (data.status) {
            case "ORDER_EXIST":
            case "EXTEND_ORDER":
            case "PAY_DEFICIENCY":
            case "PAY_ERROR":
              that.showForm = false;
              that.$set(that, "purchased", 1);
              that.$dialog.toast({ mes: res.msg });
              break;
            case "SUCCESS":
              that.showForm = false;
              that.$set(that, "purchased", 1);
              that.$dialog.success(res.msg);
              break;
            case "WECHAT_H5_PAY":
              setTimeout(() => {
                location.href = data.result.jsConfig.mweb_url;
              }, 100);
              break;
            case "WECHAT_PAY":
              pay(data.result.jsConfig).finally(() => {
                that.showForm = false;
                that.$set(that, "purchased", 1);
                that.$dialog.success("支付成功");
              });
          }
        })
        .catch(() => {});
    },
    goBrokerage() {
      window.scroll(0, 0);
      this.$router.push({ path: "/user/user_promotion"});
    },
  }
};
</script>
<style scoped>
.section-title {
  font-size: 22px;
  margin-top: 10px;
  margin-bottom: 10px;
  text-align: center;
  color: #ffde94;
}
.section-timer {
  font-size: 14px;
  margin-bottom: 10px;
  text-align: center;
  color: red;
  padding: 3px 0;
  background-color: #ffde94;
  border-bottom: 1px solid #b0802d;
}
.section-content {
  color: #ffde94;
}
.timer .section-content {
  margin: 0.32rem;
  background-color: #ffde94;
  border: 2px solid #b0802d;
  color: red;
}
.summary {
  margin: 0.32rem;
  border-radius: 0.5rem;
  background-color: #ffde94;
  border: 2px solid #b0802d;
}
.summary p {
  padding: 0.3rem;
  color: red;
}
.introduction {
 padding: 0 0.20rem 0 0.25rem;
}
.intro-content {
  background: #fff;
  border: 2px solid #ffde94;
  padding: 0.22rem;
}
.address {
  text-align: center;
}
.footer {
  position: fixed;
  bottom: 0.1rem;
  width: 100%;
  height: 0.8rem;
  color: #666;
  z-index: 5;
  padding: 0 0.2rem 0 0.3rem;
  text-align: center;
  line-height: 0.8rem;
}
.footer a.buynow {
 border-radius: 0.6rem 0 0 0.6rem;
 background: rgb(255, 222, 148, 0.85);
 color: #de0702;
 width: 50%;
 display: block;
 height: 100%;
 float: left;
 font-size: 0.32rem;
}
.footer a.share {
  border-radius: 0 0.6rem 0.6rem 0;
  background: rgb(255, 222, 148, 0.85);
  color: #de0702;
  border-left: 1px solid #de0702;
  width: 50%;
  display: block;
  float: left;
  height: 100%;
  overflow: hidden;
}
.user-info-form {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}
.user-info-form .mask {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 100;
  background-color: rgba(0,0,0,0.6);
}
.user-info-form .form{
  position: absolute;
  top: 30%;
  width: 80%;
  height: 5rem;
  border-radius: 10px;
  margin: 0 10% 0 10%;
  background: rgb(255,255,255, 1);
  z-index: 105;
}
.user-info-form .form-title {
  text-align: center;
  font-size: 18px;
  padding: 15px 0 10px 0;
}
.user-info-form .input-area {
  padding: 0 30px 0 20px;
  width: 100%;
}
.user-info-form input {
  border: 1px solid #f2f2f2;
  line-height: 30px;
  width: 80%;
  padding: 3px 0 3px 5px;
}
.user-info-form .input-item span {
  width: 20%;
}
.user-info-form .input-item {
  display: flex;
  height: 28px;
  line-height: 28px;
  margin: 5px 0 5px 0;
}
.user-info-form .button {
  text-align: center;
  margin-top: 20px;
}
.user-info-form button {
  border: 1px solid #2275da;
  border-radius: 3px;
  padding: 5px 15px 5px 15px;
  background-color: #2275da; 
  color: #fff;
}
.copyright {
  text-align: center;
  font-size: 75%;
  color: #b2b2b2;
}
.zhanwei {
  height: 0.5rem;
}
aside.right {
  position: fixed;
  width: 1.2rem;
  top: 25%;
  right: 0.12rem;
  z-index: 9;
}
aside.right-bottom {
  position: fixed;
  width: 1.2rem;
  bottom: 15%;
  right: 0.12rem;
  z-index: 9;
}
.musicIcon, .musicIconX, .phoneIcon, .shareIcon, .brokerageIcon {
  display: block;
  width: 0.9rem;
  height: 0.9rem;
  border-radius: 50%;
  margin: 0.3rem auto 0.3rem;
}
.phoneIcon {
  background: url("../../assets/images/phone.png") no-repeat center;
  background-size: auto;
  background-size: cover;
}
.shareIcon {
  background: url("../../assets/images/share.png") no-repeat center;
  background-size: auto;
  background-size: cover;
}
.musicIconX {
  background: url("../../assets/images/musicX.png") no-repeat center;
  background-size: 100%;
}
.brokerageIcon {
  background: url("../../assets/images/brokerage.png") no-repeat center;
  background-size: 85%;
  background-color: rgba(0,0,0, 0.6);
}
@-webkit-keyframes musicOn{
  0%{ -webkit-transform: rotate(0deg);}
  50%{ -webkit-transform: rotate(180deg);}
  100%{ -webkit-transform: rotate(360deg);}
}
@keyframes musicOn{
  0%{ -webkit-transform: rotate(0deg);}
  50%{ -webkit-transform: rotate(180deg);}
  100%{ -webkit-transform: rotate(360deg);}
}
.musicIcon {
  background: url("../../assets/images/music.png") no-repeat center;
  background-size: cover;
  -o-animation: musicOn 1.5s linear infinite;
  -ms-animation: musicOn 1.5s linear infinite;
  -moz-animation: musicOn 1.5s linear infinite;
  -webkit-animation: musicOn 1.5s linear infinite;
  animation: musicOn 1.5s linear infinite;
}
</style>
